export default __webpack_public_path__ + "assets/dennis-nav-logo-ce326cf.svg";